import type {
  Filters,
  LearningPath,
  LearningPathsFiltersRequest,
} from "toptaal-shared"

export const learningPathsQueryKeys = {
  all: ["learningPaths"] as const,
  filters: (request: LearningPathsFiltersRequest) =>
    [...learningPathsQueryKeys.all, "filters", request] as const,
  infiniteFilters: (request: { filters: Omit<Filters, "page"> }) =>
    [...learningPathsQueryKeys.all, "infiniteFilters", request] as const,
  detail: (learningPathId: LearningPath["id"]) =>
    [...learningPathsQueryKeys.all, "detail", learningPathId] as const,
  category: (category: string) =>
    [...learningPathsQueryKeys.all, "category", category] as const,
}
